import styled from 'styled-components';

export const EmailBodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  align-items: center;
  width: 100%;
  overflow: hidden;
  max-width: 800px;
  margin: 15px;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid #ddd;
  box-shadow: none;
  background-color: #fff;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e5e5e5;
`;
